import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { LoggingService } from '../../logging/logging.service';

@Injectable()
export class ModalService {

  private modals: Set<BsModalRef> = new Set<BsModalRef>();

  constructor(
    private modalService: BsModalService,
    private loggingService: LoggingService,
  ) {
  }

  public show(baseModalComponent: any, data: any, complite: (data: any) => void): BsModalRef {
    let modalRef = this.modalService.show(
      baseModalComponent,
      {
        animated: false,
        keyboard: false,
        backdrop: true,
        ignoreBackdropClick: true
      });

    this.modals.add(modalRef);

    this.logModalChangeState(modalRef, 'show');
    modalRef.content.data = data;

    const eventCloseSubscription = modalRef.content.eventClose.subscribe(
      (eventData) => {
        this.logModalChangeState(modalRef, 'eventClose');
        eventCloseSubscription.unsubscribe();
        if (modalRef) {
          this.modals.delete(modalRef);
          modalRef.hide();
          modalRef = null;
        }
        if (complite) {
          complite(eventData);
        }
      });

    return modalRef;
  }

  public close(modalRef: BsModalRef) {
    if (modalRef && modalRef.content) {
      setTimeout(() => {
        this.logModalChangeState(modalRef, 'close');
        modalRef.content.close();
      }, 0);
    }
  }

  public closeAll() {
    if (this.modals.size === 0) {
      return;
    }

    this.loggingService.info(`ModalService. closeAll. Modal count: ${this.modals.size}`);

    for (const modal of this.modals) {
      this.close(modal);
    }

    this.modals.clear();
  }

  private logModalChangeState(modalRef: BsModalRef, state: string) {
    if (!modalRef || !modalRef.content || !modalRef.content.constructor || !modalRef.content.constructor.name) {
      return;
    }

    this.loggingService.info(`ModalService. ${state}. Modal name: ${modalRef.content.constructor.name}`);
  }
}
